/** A section title and the question the section answers, on one measure grid. */
const SectionHead = ({
  title,
  question,
}: {
  title: string
  question?: string
}) => (
  <header className="grid items-baseline gap-2 md:grid-cols-[220px_1fr]">
    <h2 className="text-lg font-semibold tracking-tight">{title}</h2>
    {question && <p className="text-muted text-sm">{question}</p>}
  </header>
)

export default SectionHead
